import {
  APPLICATIONINSIGHTS_CONNECTION_STRING,
  isBrowser,
  isProduction,
} from "appConfiguration";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import {
  ApplicationInsights,
  type IConfig,
  type IConfiguration,
} from "@microsoft/applicationinsights-web";

export const reactPlugin = new ReactPlugin();
const appInsightsConfig: IConfiguration & IConfig = {
  connectionString: APPLICATIONINSIGHTS_CONNECTION_STRING,
  enableAutoRouteTracking: true,
  extensions: [reactPlugin],
};
export const appInsights = new ApplicationInsights({
  config: appInsightsConfig,
});
if (isBrowser && isProduction) {
  try {
    appInsights.loadAppInsights();
  } catch {
    console.error({ appInsightsConfig });
    console.error("failed to load appInsights");
  }
}
